import React from 'react';
import { Footer } from '../Common/Footer';
import { SideBar } from '../Common/SideBar';
import { Link } from 'react-router-dom';
import FollowFavourite from '../../Models/FollowFavourites';
import { Header } from '../Common';
import { withTranslation } from 'react-i18next';
import Common from "../../Models/Common";
class Followers extends React.Component {
    constructor(props) {
        super(props);
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('GLOBAL.PLEASE_LOGIN'));

            this.props.history.push('/login/seller');
        };
        this.state = {
            _id: false,
            followers: [],
            logged_user_id: ''
        };
        this.state.logged_user_id = logged_user.id;
        this.getMyFollowers();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getMyFollowers() {
        FollowFavourite.getFollowers(this.state.logged_user_id).then(res => {
            this.setState({ followers: res.data.payload })
            console.log(this.state.followers)
            console.log(res.data.payload)
        })
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="row">
                            {/* <div className="col-md-4">
                                <SideBar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font guide_text" style={{ width: '100%', fontSize: '20px' }}>
                                    {this.props.t('SELLER_DASHBOARD.FOLLOWERS')}
                                        </div>
                                {(() => {
                                    if (this.state.followers.length === 0) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div style={{ border: "1px solid #bababa", minHeight: "550px" }}>
                                                {this.state.followers.map(group =>
                                                    <div style={{ padding: "4%", borderBottom: "1px solid #bababa" }}>
                                                        <img className="rounded-circle" style={{ borderRadius: "50%" }} alt="" src={Common.baseUrl + group.img} height="50" width='50' />&nbsp;&nbsp;
                                                        <Link to={{
                                                            pathname: `/buyer-my-profile-view/users/${group.buyer_id}`,
                                                            state: { id: group.buyer_id }
                                                        }} className="sky-a ml-3">{group.first_name}</Link>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: '100%' }}>
                                            {this.props.t('SELLER_DASHBOARD.FOLLOWERS')}
                                    </div>
                                        {(() => {
                                            if (this.state.followers.length === 0) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div style={{ border: "1px solid #bababa", minHeight: "550px" }}>
                                                        {this.state.followers.map(group =>
                                                            <div style={{ padding: "4%", borderBottom: "1px solid #bababa" }}>
                                                                <img className="rounded-circle" style={{ borderRadius: "50%" }} alt="" src={Common.baseUrl + group.img} height="50" width='50' />&nbsp;&nbsp;
                                                            <Link to={{
                                                                    pathname: `/buyer-my-profile-view/users/${group.buyer_id}`,
                                                                    state: { id: group.buyer_id }
                                                                }} className="sky-a ml-3">{group.first_name}</Link>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { Followers }
Followers = withTranslation('seller')(Followers);
